<template>
<div class="form-details">

<div  v-if="form">
  <div class="tabs is-centered">
    <ul>
      <li v-for="(tab, index) in tabs" :key="index" @click="selectedTab = tab"
      v-bind:class="{'active':(selectedTab == tab)}">
        <router-link v-if="tab === 'details'" :to="{ path: `/${form.id}/` }">{{tab}}</router-link>
        <router-link v-else :to="{ path: `/${form.id}/${tab}` }">{{tab}}</router-link>
      </li>
    </ul>
  </div>

  <forms-details v-if="selectedTab === 'details'" :form="form" @updated="updated"></forms-details>
  <stats v-if="selectedTab === 'details'" :formId="form.id"/>

  <forms-entries v-if="selectedTab === 'entries'"
    :form="form"></forms-entries>

  <forms-edit
    v-if="selectedTab === 'edit' && !this.$store.state.user" :form="form" @updated="updated">
  </forms-edit>

  <forms-html v-if="selectedTab === 'html'" :form="form">
  </forms-html>

</div>
<div v-else>
  <stats/>
</div>

</div>
</template>

<script>
import Stats from '@/components/Stats';
import FormsDetails from '@/components/Forms/Details';
import FormsEdit from '@/components/Forms/Edit';
import FormsEntries from '@/components/Forms/Entries';
import FormsHtml from '@/components/Forms/HTML';
import FormsService from '@/services/Forms';

export default {
  data() {
    return {
      selectedTab: 'details',
      tabs: ['details', 'entries', 'edit', 'html'],
      form: '',
      routeForm: null,
      chartData: null,
    };
  },
  watch: {
    async $route(to) {
      if (to.name === 'Dashboard') {
        this.routeForm = null;
        this.form = null;
      }
      if (to.name === 'Form-entries') {
        this.routeForm = to.params.id;
      }
      if (to.name === 'Form-details') this.routeForm = to.params.id;
      // if (to.name === 'Form-details') this.selectedTab = 'details';
      // if (to.name === 'Form-edit') this.selectedTab = 'edit';
    },
    async routeForm(val) {
      if (val) this.form = (await FormsService.getForm(val)).data;
    },
  },
  updated() {
    if (this.$route.name === 'Form-details') this.selectedTab = 'details';
    if (this.$route.name === 'Form-entries') this.selectedTab = 'entries';
    if (this.$route.name === 'Form-entries-entryId') this.selectedTab = 'entries';
    if (this.$route.name === 'Form-edit') this.selectedTab = 'edit';
    if (this.$route.name === 'Form-html') this.selectedTab = 'html';
  },
  async created() {
    this.routeForm = this.$route.params.id;
    if (this.routeForm) this.form = (await FormsService.getForm(this.routeForm)).data;
    if (this.$store.state.user) this.tabs = ['details', 'entries'];
  },
  methods: {
    async updated(updatedForm) {
      this.$emit('updated', updatedForm);
      this.form = (await FormsService.getForm(updatedForm.id)).data;
      this.$router.push(`/${updatedForm.id}`);
      this.selectedTab = 'details';
    },
  },
  components: {
    Stats,
    FormsDetails,
    FormsEdit,
    FormsEntries,
    FormsHtml,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  main { padding: 2em; }

  .tabs {
    position: sticky;
    top: 0;
    background: var(--white);
    z-index: 1;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14),
      0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);
  }

  .tabs a {
    color: var(--white);
    text-transform: uppercase;
    text-decoration: none;
    padding: 15px 40px;
    font-size: 125%;
  }

  .tabs a:focus {
    outline: none;
  }

  .tabs ul {
    margin: 0;
    padding: 15px;
    display: flex;
    justify-content: space-around;
    list-style-type: none;
    background: var(--black);
  }
  .tabs ul li {
    display: inline-block;
    position: relative;
  }

  .tabs ul li.active:after, .tabs ul li:hover:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -15px;
    width: 100%;
    height: 5px;
    background :white;
  }

</style>
